import { generateUniqueID } from "../utils/generateUniqueID";
import img1 from "../assets/_home/popularCollection1.png";
import img2 from "../assets/_home/popularCollection2.png";
import img3 from "../assets/_home/popularCollection3.png";
import img4 from "../assets/_home/popularCollection4.png";
import img5 from "../assets/_home/popularCollection5.png";
import img6 from "../assets/_home/popularCollection6.png";

export const popular = [
  {
    id: generateUniqueID(),
    name: "Bored Apes",
    creator: {
      name: "Jake12",
      img: img1,
    },
    total: 64,
    collectionImg: img1,
    images: [img1, img1, img1],
  },
  {
    id: generateUniqueID(),
    name: "Azuki Doodles",
    creator: {
      name: "Azuki",
      img: img2,
    },
    total: 123,
    collectionImg: img2,
    images: [img2, img2, img2],
  },
  {
    id: generateUniqueID(),
    name: "Bored Apes",
    creator: {
      name: "Jake12",
      img: img3,
    },
    total: 64,
    collectionImg: img3,
    images: [img3, img3, img3],
  },
  {
    id: generateUniqueID(),
    name: "Azuki Doodles",
    creator: {
      name: "Azuki",
      img: img4,
    },
    total: 123,
    collectionImg: img4,
    images: [img4, img4, img4],
  },
  {
    id: generateUniqueID(),
    name: "Bored Apes",
    creator: {
      name: "Jake12",
      img: img5,
    },
    total: 64,
    collectionImg: img5,
    images: [img5, img5, img5],
  },
  {
    id: generateUniqueID(),
    name: "Azuki Doodles",
    creator: {
      name: "Azuki",
      img: img6,
    },
    total: 123,
    collectionImg: img6,
    images: [img6, img6, img6],
  },
  {
    id: generateUniqueID(),
    name: "Bored Apes",
    creator: {
      name: "Jake12",
      img: img1,
    },
    total: 64,
    collectionImg: img1,
    images: [img1, img1, img1],
  },
  {
    id: generateUniqueID(),
    name: "Azuki Doodles",
    creator: {
      name: "Azuki",
      img: img2,
    },
    total: 123,
    collectionImg: img2,
    images: [img2, img2, img2],
  },
  {
    id: generateUniqueID(),
    name: "Bored Apes",
    creator: {
      name: "Jake12",
      img: img3,
    },
    total: 64,
    collectionImg: img3,
    images: [img3, img3, img3],
  },
  {
    id: generateUniqueID(),
    name: "Azuki Doodles",
    creator: {
      name: "Azuki",
      img: img4,
    },
    total: 123,
    collectionImg: img4,
    images: [img4, img4, img4],
  },
  {
    id: generateUniqueID(),
    name: "Bored Apes",
    creator: {
      name: "Jake12",
      img: img5,
    },
    total: 64,
    collectionImg: img5,
    images: [img5, img5, img5],
  },
  {
    id: generateUniqueID(),
    name: "Azuki Doodles",
    creator: {
      name: "Azuki",
      img: img6,
    },
    total: 123,
    collectionImg: img6,
    images: [img6, img6, img6],
  },
];
